import { render } from "./multipleQuotes.vue?vue&type=template&id=21afdca0&lang=true"
import script from "./multipleQuotes.vue?vue&type=script&lang=js"
export * from "./multipleQuotes.vue?vue&type=script&lang=js"

import "./multipleQuotes.vue?vue&type=style&index=0&id=21afdca0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__